import { isString, isUndefined } from 'lodash-es'
import { useQuery } from '@tanstack/react-query'
import { Skeleton } from 'antd'
import { CSSProperties } from 'react'
import { getFileBase64 } from 'src/utils/download'

export const AsyncImage: React.FC<{
  alt: string
  width?: number
  height?: number
  style?: CSSProperties
  cacheKey?: string
  loader: (() => Promise<string>) | string
}> = ({ alt, width, height, loader, style, cacheKey }) => {
  const { isLoading, data, isError } = useQuery<string>(
    ['image', cacheKey ?? loader],
    () => {
      return isString(loader) ? getFileBase64(loader) : loader()
    },
    { staleTime: 60_000, enabled: !isUndefined(loader) }
  )

  if (isLoading) {
    return <Skeleton.Image style={{ ...style, width, height }} />
  }

  if (isError || !data) {
    return <Skeleton.Image style={{ ...style, width, height }} />
  }

  return (
    <img alt={alt} width={width} height={height} src={data} style={{ objectFit: 'contain', ...style }} />
  )
}
